import {useEffect} from 'react';

type Props = {
  containerRef: React.RefObject<HTMLElement>;
  onScrollToBottom: () => void;
};
export const useScrollToBottom = ({containerRef, onScrollToBottom}: Props) => {
  useEffect(() => {
    const container = containerRef.current;
    let scrollHandler = null;
    if (container) {
      scrollHandler = () => {
        const {scrollTop, clientHeight, scrollHeight} = container;

        if (scrollTop + clientHeight >= scrollHeight) {
          onScrollToBottom();
        }
      };
      container.addEventListener('scroll', scrollHandler);
    }
    return () => {
      if (scrollHandler) container?.removeEventListener('scroll', scrollHandler);
    };
  }, [containerRef, onScrollToBottom]);
};
